<template lang="pug">
  .layout-view(:class="offset")
    controls-panel(
      @update="refresh")
    storage-tabs
    stock-panel(
      @update-stock-data="refresh")
    ingredients-table(
      v-if="!isMobile"
      @update="refresh"
      ref="table")
    ingredients-table-mobile(
      v-else
      @update="refresh"
      ref="table")
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'

import ControlsPanel from './ControlsPanel'
import StorageTabs from '../common/StorageTabs'
import StockPanel from '../common/StockPanel'
const IngredientsTableMobile = () => import('./table/IngredientsTableMobile')
const IngredientsTable = () => import('./table/IngredientsTable')

export default {
  name: 'Ingredients',

  mixins: [adaptationMixin],

  components: {
    ControlsPanel,
    StorageTabs,
    StockPanel,
    IngredientsTable,
    IngredientsTableMobile
  },

  computed: {
    offset () {
      return {
        'layout-view--offset-top': false
      }
    }
  },

  methods: {
    refresh (stockId, currentPage) {
      if (this.$refs.table) {
        if (this.$refs.table.loadData) {
          this.$refs.table.params.stock = stockId
          this.$refs.table.params.page = currentPage
          this.$refs.table.loadData()
        }
        if (this.$refs.table.loadDailyFeedIntakes) {
          this.$refs.table.loadDailyFeedIntakes()
        }
      }
    }
  }
}
</script>
